<template>
  <div class="row">
    <div class="col-md-10 col-md-offset-1">
      <h3>
        Condizioni d'uso: come funziona il sito
        <NomeSitoPiccolo />.
      </h3>
      <br />
      <p style="width: 80%; margin: auto; text-align: justify">
        <strong>
          Facile Check-in è un servizio in cloud finalizzato alla gestione del
          check-in online. Il sito mette a disposizione dei clienti che abbiano
          effettuato una prenotazione presso una struttura ricettiva, una pagina
          attraverso la quale inserire i dati anagrafici dei componenti la
          prenotazione (dati di check-in). Tali dati saranno poi acquisiti
          automaticamente negli archivi della struttura ricettiva interessata.
        </strong>
      </p>
      <br />

      <h4>Nel seguito verranno usati i seguenti termini:</h4>
      <p class="rientro">
        <strong>Facile Check-in</strong> è il servizio in cloud (questo sito)
        che fornisce il servizio di check-in online. Nel seguito, Facile
        Check-in sarà indicato anche come “il sito”.
      </p>
      <p class="rientro">
        <strong>Partner</strong>: è un'azienda (tipicamente un sofware-house)
        che ha integrato le funzionalità di Facile Check-in all'interno del
        gestionale da lei fornito alle strutture ricettive sue clienti.
      </p>
      <p class="rientro">
        <strong>Struttura Ricettiva</strong>: la struttura ricettiva per la
        quale sia stato attivato, da parte del Partner, l'utilizzo di Facile
        Check-in all'interno del software gestionale.
      </p>
      <p class="rientro">
        <strong>Cliente Finale</strong>: la persona fisica che ha effettuato la
        prenotazione presso una Struttura Ricettiva e che viene invitata ad
        inserire nel sito i dati dei componenti la prenotazione, dati che
        saranno necessari al momento dell'accettazione in struttura.
      </p>
      <p class="rientro">
        <strong>Esempio</strong>: una casa di software (Partner) fornisce il
        proprio software gestionale alle strutture ricettive sue clienti. Il
        software gestionale non possiede già un check-in online integrato e
        pertanto la casa di software intende utilizzare le funzionalità di
        Facile Check-in per fornire un nuovo servizio alle strutture clienti.
        Dopo la necessaria integrazione telematica tra il gestionale ed il sito,
        la struttura ricettiva sarà in grado di indirizzare i propri clienti
        alla pagina tramite la quale inserire i propri dati e, successivamente,
        ricevere tali dati automaticamente all'interno dei propri archivi.
      </p>
      <br />
      <h4>Utilizzo delle funzionalità del sito</h4>
      <p class="rientro">
        Dopo essersi registrato, il Partner può utilizzare le funzionalità del
        sito e riceve la documentazione necessaria per integrarlo all'interno
        del suo software gestionale.
      </p>
      <p class="rientro">
        Il Partner accede al sito e attiva Facile Check-in per le Strutture che
        ne avessero fatto richiesta. Dal quel momento, i Clienti della Struttura
        Ricettiva verranno indirizzati alla pagina del check-in online e i loro
        dati saranno trasferiti automaticamente all'interno degli archivi della
        Struttura stessa.
      </p>

      <br />

      <hr />

      <h3>Informativa sul trattamento dei dati personali</h3>
      <br />
      <h4>1. Premessa</h4>
      <p class="rientro">
        La presente informativa viene resa ai sensi del D. Lgs. n. 196/2003 (il
        “Codice Privacy“) e del nuovo Regolamento Europeo n. 679/2016 in materia
        di protezione dei dati personali (il “Regolamento Privacy“). Tale
        informativa si applica al sito “Facile Check-in” (nel seguito “il sito”)
        nella sua globalità. Informative specifiche e semplificate, saranno
        fornite in sede di registrazione nuovo account, richiesta di
        informazioni o inserimento dei dati di check-in.
      </p>
      <br />

      <h4>2. Fonte dei dati personali</h4>
      <p class="rientro">
        I dati personali raccolti tramite il sito Facile Check-in sono di
        duplice natura:
      </p>
      <ol class="doppio-rientro">
        <li>
          dati raccolti dal sito stesso relativamente ai Partner, alle Strutture
          Ricettive o a soggetti richiedenti informazioni
        </li>
        <li>
          dati raccolti ed inseriti nel sito da parte dei suoi utilizzatori
          (Partner, Clienti Finali).
        </li>
      </ol>
      <p class="rientro">
        <strong
          >Segue informativa dettagliata per ciascuno dei tipi di dato
          raccolti.</strong
        >
      </p>
      <br />

      <h4>3. Dati personali raccolti direttamente dal sito</h4>
      <h4 class="rientro">3.1 Titolare del Trattamento</h4>
      <p class="doppio-rientro">
        Per questa tipologia di dati, il Titolare del Trattamento è il Sig.
        Claudio De Nardi, P.IVA 03513050264, con sede legale in Via Ungheresca
        Nord, 144 – Mareno di Piave (TV), che può essere raggiunto tramite email
        all'indirizzo: administrator@checkin.loquos.it
      </p>
      <br />
      <h4 class="rientro">3.2 Modalità di Conferimento dei dati</h4>
      <p class="doppio-rientro">
        I dati vengono raccolti tramite form dedicati, in fase di registrazione
        nel sito o richiesta di informazioni. Tali dati sono:
      </p>
      <ul class="triplo-rientro">
        <li>Indirizzo Email</li>
        <li>Ragione Sociale</li>
        <li>Indirizzo completo</li>
        <li>Telefono</li>
        <li>Lingua</li>
      </ul>
      <br />

      <h4 class="rientro">3.3 Finalità del trattamento</h4>
      <p class="doppio-rientro">
        I dati personali di cui al punto 3.2 verranno utilizzati per permettere
        la creazione di un nuovo account del sito, per rispondere a richieste di
        informazioni e per raccogliere dati anagrafici e di contatto delle
        Strutture Ricettive.
      </p>
      <br />

      <h4 class="rientro">3.4 Modalità di trattamento dei dati</h4>
      <p class="doppio-rientro">
        In relazione alle finalità descritte, il trattamento dei dati personali
        avviene mediante strumenti automatici, al fine di compiere le operazioni
        richieste. I dati vengono conservati in un data center situato in Italia
        e che ha conseguito la certificazione ISO 27001 (sistema di gestione per
        la sicurezza delle informazioni).
      </p>
      <br />

      <h4 class="rientro">3.5. Facoltatività del conferimento dei dati</h4>
      <p class="doppio-rientro">
        Il conferimento dei dati è richiesto se un nuovo Partner intende
        registrarsi nel sito, un soggetto richiede delle informazioni o una
        Struttura Ricettiva intende iniziare ad utilizzare le funzionalità del
        sito.
      </p>
      <p class="doppio-rientro">
        Nei primi due casi verrà richiesto unicamente un indirizzo email,
        attraverso il quale il sito potrà comunicare con il Partner o il
        richiedente informazioni.
      </p>
      <p class="doppio-rientro">
        Nel secondo caso verranno richiesti i dati anagrafici e di contatto
        della Struttura Ricettiva.
      </p>
      <br />

      <h4 class="rientro">3.6. Minori di 18 anni</h4>
      <p class="doppio-rientro">
        I servizi del sito Facile Check-in sono riservati a titolari di attività
        economiche e pertanto non vengono raccolti intenzionalmente dati
        personali di minori. Nel caso in cui informazioni su minori fossero
        involontariamente registrate, il Titolare le cancellerà in modo
        tempestivo, su richiesta degli utenti.
      </p>
      <br />

      <h4 class="rientro">
        3.7. Categorie di soggetti ai quali i dati possono essere comunicati
      </h4>
      <p class="doppio-rientro">
        L'email inserita in fase di registrazione dell'account (o eventualmente
        modificata in seguito), è trattata in maniera automatica e non è
        comunicata ad alcun soggetto.
      </p>
      <p class="doppio-rientro">
        Quella inserita in fase di richiesta di informazioni, verrà comunicata
        al personale addetto a soddisfare la richiesta.
      </p>
      <p class="doppio-rientro">
        Infine, i dati relativi alla Struttura Ricettiva saranno visualizzati
        nella pagina web di inserimento dei dati di check-in, per permettere al
        Cliente Finale di individuare senza equivoci la struttura presso la
        quale ha effettuato la prenotazione. La pagina che visualizza tali dati
        personali, sarà accessibile solamente al Cliente Finale che abbia
        effettuato una prenotazione e che pertanto sia in possesso di un link di
        accesso al sito.
      </p>
      <br />

      <h4 class="rientro">3.8. Durata della conservazione dei dati</h4>
      <p class="doppio-rientro">
        I dati relativi ai Partner o alle Strutture Ricettive verranno
        conservati fintantoché sia attivo l'account creato in fase di
        registrazione. La definitiva eliminazione dei dati relativi al Partner o
        alla Struttura Ricettiva e, contestualmente, di tutti i dati collegati,
        potrà avvenire solamente tramite richiesta esplicita, inviando un'email
        all'indirizzo administrator@checkin.loquos.it. Prima di inoltrare tale
        richiesta il Partner o la Struttura Ricettiva potranno ricevere tutti i
        dati personali di loro competenenza in formato elettronico, compatibile
        con i software di uso comune.
      </p>
      <p class="doppio-rientro">
        I dati inseriti in fase di richiesta di informazioni verranno conservati
        il tempo necessario a soddisfare la richiesta ed immediatamente
        eliminati.
      </p>
      <br />

      <h4 class="rientro">3.9. Base giuridica del trattamento</h4>
      <p class="doppio-rientro">
        Il trattamento dell'indirizzo email fornito in sede di registrazione
        dell'account, è obbligatorio per permettere una verifica della validità
        del processo di registrazione e conseguentemente consentire all'utente
        di utilizzare liberamente i servizi del sito.
      </p>
      <p class="doppio-rientro">
        Il trattamento dell'indirizzo email fornito in sede di richiesta di
        informazioni, è indispensabile per poter soddisfare la richiesta.
      </p>
      <p class="doppio-rientro">
        Il trattamento dei dati relativi alle Strutture Ricettive è
        indispensabile per fornire al Cliente Finale i riferimenti della
        struttura presso la quale ha effettuato la prenotazione.
      </p>
      <br />

      <h4>
        4. Dati raccolti ed inseriti nel sito da parte dei suoi utilizzatori
        (Partner, Clienti Finali).
      </h4>
      <br />

      <h4 class="rientro">
        4.1 Titolare del Trattamento e Responsabile del Trattamento
      </h4>
      <p class="doppio-rientro">
        Per questa tipologia di dati, il Titolare del Trattamento è il Partner
        per quanto riguarda i dati relativi alle Strutture Ricettive sue
        clienti, e la Struttura Ricettiva per quanto riguarda i dati di check-in
        inseriti nel sito dai Clienti Finali.
      </p>
      <p class="doppio-rientro">
        Il Titolare del Trattamento (Partner o Struttura Ricettiva) nominerà
        come Responsabile del Trattamento il Sig. Claudio De Nardi, P.IVA
        03513050264, con sede legale in Via Ungheresca Nord, 144 – Mareno di
        Piave (TV), che può essere raggiunto tramite email all'indirizzo:
        administrator@checkin.loquos.it
      </p>
      <br />

      <h4 class="rientro">4.2 Modalità di Conferimento dei dati</h4>
      <p class="doppio-rientro">
        Per quanto riguarda i dati inseriti dal Partner, si rimanda alla sua
        informativa.
      </p>
      <p class="doppio-rientro">
        Per quanto riguarda i dati di check-in inseriti dai Clienti Finali, il
        conferimento avviene tramite lo specifico form del sito.
      </p>
      <br />

      <h4 class="rientro">4.3. Finalità del trattamento</h4>
      <p class="doppio-rientro">
        Per questa tipologia di dati si rimanda all'informativa del Titolare del
        Trattamento (Partner o Struttura Ricettiva).
      </p>
      <br />

      <h4 class="rientro">4.4. Modalità di trattamento dei dati</h4>
      <p class="doppio-rientro">
        Da parte del sito, le informazioni inserite verranno trattate con mezzi
        esclusivamente automatici, per permettere la loro memorizzazione e
        aggiornamento. I dati vengono conservati in un data center situato in
        Italia e che ha conseguito la certificazione ISO 27001 (sistema di
        gestione per la sicurezza delle informazioni). Per accedere ai dati è
        necessario eseguire il login fornendo utente e password che sono
        conosciuti solo dal Titolare del Trattamento (Partner o Struttura
        Ricettiva) o dai suoi incaricati. In caso di smarrimento della password,
        l'utente può richiederne il recupero in autonomia senza necessità di
        interventi manuali da parte di operatori.
      </p>
      <p class="doppio-rientro">
        Per altre informazioni, si rimanda all'informativa del Titolare del
        Trattamento (Partner o Struttura Ricettiva).
      </p>
      <br />

      <h4 class="rientro">4.5. Facoltatività del conferimento dei dati</h4>
      <p class="doppio-rientro">
        Per questa tipologia di dati si rimanda all'informativa del Titolare del
        Trattamento (Azienda Cliente).
      </p>
      <br />

      <h4 class="rientro">4.6. Minori di 18 anni</h4>
      <p class="doppio-rientro">
        Per questa tipologia di dati si rimanda all'informativa del Titolare del
        Trattamento (Azienda Cliente).
      </p>
      <br />

      <h4 class="rientro">
        4.7. Categorie di soggetti ai quali i dati possono essere comunicati
      </h4>
      <p class="doppio-rientro">
        I dati personali inseriti nel sito dal Partner e relativi alle Strutture
        Ricettive sue clienti, non verranno comunicati da parte del sito ad
        alcun soggetto in nessuna circostanza.
      </p>
      <p class="doppio-rientro">
        I dati di check-in inseriti dai Clienti Finali, verranno comunicati alla
        Struttura Ricettiva presso la quale è stata effettuata la prenotazione.
      </p>
      <p class="doppio-rientro">
        Per altre informazioni, si rimanda all'informativa del Titolare del
        Trattamento (Partner o Struttura Ricettiva).
      </p>
      <br />

      <h4 class="rientro">4.8. Durata della conservazione dei dati</h4>
      <p class="doppio-rientro">
        Da parte del sito, tutti i dati inseriti, verranno conservati
        fintantoché sia attivo l'account creato in fase di registrazione.
      </p>
      <p class="doppio-rientro">
        Su richiesta esplicita del Partner o della Struttura Ricettiva
        all'indirizzo administrator@checkin.loquos.it, potrà essere effettuata
        da parte del sito l'eliminazione totale o parziale dei dati inseriti e,
        all'occorrenza anche dei dati stessi del Partner o Struttura Ricettiva,
        causando in tal modo la chiusura definitiva dell'account. Prima di
        inoltrare tale richiesta, il Partner o la Struttura Ricettiva potranno
        ottenere copia dei dati a loro collegati, in formato elettronico,
        compatibile con i software di uso comune.
      </p>
      <br />

      <h4 class="rientro">4.9. Base giuridica del trattamento</h4>
      <p class="doppio-rientro">
        Dal punto di vista del sito e quindi del Responsabile del Trattamento,
        il trattamento dei dati inseriti dal Partner o dati Clienti Finali è
        necessario per il pieno utilizzo delle funzionalità del sito.
      </p>
      <p class="doppio-rientro">
        Per altre informazioni, si rimanda all'informativa del Titolare del
        Trattamento (Parter o Struttura Ricettiva).
      </p>
      <br />

      <h4>5. Diritti dell'Interessato</h4>
      <p class="rientro">
        L'interessato ha il diritto di ottenere dal titolare del trattamento la
        conferma che sia o meno in corso un trattamento di dati personali che lo
        riguardano e in tal caso, di ottenere l'accesso ai dati personali e alle
        seguenti informazioni:
      </p>
      <ul class="doppio-rientro" style="list-style-type: lower-alpha">
        <li>le finalità del trattamento;</li>
        <li>le categorie di dati personali in questione;</li>
        <li>
          i destinatari o le categorie di destinatari a cui i dati personali
          sono stati o saranno comunicati, in particolare se destinatari di
          paesi terzi o organizzazioni internazionali;
        </li>
        <li>
          quando possibile, il periodo di conservazione dei dati personali
          previsto oppure, se non è possibile, i criteri utilizzati per
          determinare tale periodo;
        </li>
        <li>
          l'esistenza del diritto dell'interessato di chiedere al titolare del
          trattamento la rettifica o la cancellazione dei dati personali o la
          limitazione del trattamento dei dati personali che lo riguardano o di
          opporsi al loro trattamento;
        </li>
        <li>il diritto di proporre reclamo a un'autorità di controllo;</li>
        <li>
          qualora i dati non siano raccolti presso l'interessato, tutte le
          informazioni disponibili sulla loro origine;
        </li>
        <li>
          l'esistenza di un processo decisionale automatizzato, compresa la
          profilazione di cui all'articolo 22, paragrafi 1 e 4, e, almeno in
          tali casi, informazioni significative sulla logica utilizzata, nonché
          l'importanza e le conseguenze previste di tale trattamento per
          l'interessato.
        </li>
      </ul>
      <p class="rientro">
        Qualora i dati personali siano trasferiti a un paese terzo o a
        un'organizzazione internazionale, l'interessato ha il diritto di essere
        informato dell'esistenza di garanzie adeguate ai sensi dell'articolo 46
        relative al trasferimento.
      </p>
      <p class="rientro">
        Il titolare del trattamento fornisce una copia dei dati personali
        oggetto di trattamento. In caso di ulteriori copie richieste
        dall'interessato, il titolare del trattamento può addebitare un
        contributo spese ragionevole basato sui costi amministrativi. Se
        l'interessato presenta la richiesta mediante mezzi elettronici, e salvo
        indicazione diversa dell'interessato, le informazioni sono fornite in un
        formato elettronico di uso comune.
      </p>
      <br />
      <h4>6. Policy sui cookie</h4>
      <p class="rientro">
        Il sito Facile Check-in utilizza esclusivamente cookie tecnici, al fine
        di garantire la normale navigazione e fruizione del sito. Per tale tipo
        di cookie non è richiesto il preventivo consenso da parte degli utenti.
      </p>

      <br />

      <b-btn to="/login" variant="success" style="width: 100%"
        >Ritorna alla Home Page</b-btn
      >
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import NomeSitoPiccolo from "@/components/NomeSitoPiccolo.vue";

export default {
  name: "PrivacyRegistrazionePartner",
  data() {
    return {};
  },
  components: {
    NomeSitoPiccolo,
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {};
    let labels_inglese = {};
    let labels_tedesco = {};
    let labels_francese = {};

    let labels_errori_italiano = {};
    let labels_errori_inglese = {};
    let labels_errori_tedesco = {};
    let labels_errori_francese = {};

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "InformativaSito-fn_CambiaLingua");
  }
}
</script>

<style scoped>
.rientro {
  padding-left: 20px;
  text-align: justify;
}
.doppio-rientro {
  padding-left: 40px;
  text-align: justify;
}
.triplo-rientro {
  padding-left: 60px;
  text-align: justify;
}
</style>
